export const SET_MENU_CATEGORIES = 'SET_MENU_CATEGORIES';
export const GET_MENU_CATEGORIES_REQUEST = 'GET_MENU_CATEGORIES_REQUEST';

export const getMenuCategoriesRequest = (onComplete) => ({
  type: GET_MENU_CATEGORIES_REQUEST,
  onComplete
});
